import styled from 'styled-components'
import Colors from 'builder/styles/colors'
import Media from 'builder/styles/media'

export const Container = styled.div`
  padding-top: 52px;
  height: 100%;

  ${Media.Phone`
    padding-top: 62px;
`};

  ${Media.Tablet`
    padding: 52px 0 32px;
  `}
`

export const ContentSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 36px;
  background-color: ${Colors.White};
  transition: all 200ms ease-in;
  padding-bottom: 84px;
  min-height: 100%;
  border-radius: 12px 12px 0 0;

  ${Media.Phone`
    padding: 0 0 102px;
  `};
`
